export enum WebPaymentOrderType {
  Pay = 0,
  Recharge = 1,
}
